import request from '@/utils/request'

/**
 * 获取提现申请列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回提现申请列表
 */
export function getWithdrawalApplyList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountWithdrawalApply/listStateWithdrawalApplys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新提现申请状态
 * @param {Object} data 更新数据
 * @returns {Promise} 返回更新结果
 */
export function updateWithdrawalApply(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountWithdrawalApply/upAccountWithdrawalApply',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}